import type { Wire } from '../model/wire.js';
import type { PinDef } from '../library/component-def.js';
import type { PinState } from '../model/pin.js';

/** Diámetro visual del cable en mm (define wBase del renderer). */
export const WIRE_DIAMETER_MM = 0.70;

/**
 * Convierte un `Wire` a un par `PinDef` + `PinState` sintéticos que
 * pueden alimentar directamente `computePinPath3D`, `renderFlatPin`
 * y `renderBendMarks`. La `attachment` se coloca en world-coords
 * porque el grupo del cable se dibuja con position (0, 0).
 */
export function wireAsPin(wire: Wire): { def: PinDef; state: PinState } {
  const def: PinDef = {
    id: wire.uid,
    attachment: { x: wire.from.x, y: wire.from.y },
    direction_deg: wire.direction_deg,
    length_mm: 1, // ignorado: computePinPath3D usa segmentLengthFor()
    diameter_mm: WIRE_DIAMETER_MM,
    bend_points_count: wire.bend_points_count,
    shape: 'flat',
    tip_ratio: 1,
    material: 'tinned',
  };
  const state: PinState = {
    pin_id: wire.uid,
    bends: wire.bends,
    cut_at_index: wire.cut_at_index,
  };
  return { def, state };
}
